import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { styled } from 'styled-components'

import { zIndexes } from '../../../theme/zIndexes'
import { SegmentCard } from '../Segment/Segment.Styled'

export const StyledWrapper = styled(SegmentCard)`
  padding: 4px;
`

export const StyledHeader = styled.div`
  display: grid;
  align-items: center;
  padding: 4px 8px;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
  text-align: center;
`

export const StyledGoalImages = styled.div`
  position: relative;
  display: flex;
  justify-content: space-around;
  border-radius: ${({ theme }) => theme.radius['Radius MD']}px;
  background: ${({ theme }) => theme.colors['N Surface/Secondary']};
`

export const StyledBodyImage = styled.img`
  z-index: ${zIndexes.paywallVisualGoalComparisonBodyImage};
  overflow: hidden;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const StyledArrowWrapper = styled.div`
  position: absolute;
  z-index: ${zIndexes.paywallVisualGoalComparisonChevron};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${StyledIcon} {
    width: 100px;
    height: 100px;
  }
`

export const StyledAttributesWrapper = styled.div`
  display: grid;
  padding: 12px;
  gap: 26px;
  grid-template-columns: 1fr 1fr;
`

export const StyledAttributesColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
